<template>
  <m-form
    :title="title"
    :items="items"
    :showList="true"
    :cols="cols"
    :canSubmit="canSubmit"
    :canDelete="canDelete"
    :showClearBtn="false"
    :hasExport="false"
    :is-editing.sync="isEditing"
    :showListBtn="false"
    :show-navigation-btns="false"
    @click:row="setItem"
    @clearForm="clearForm"
    @submit="submit"
    @delete="deleteItem"
  >
    <template #default>
      <v-row>
        <v-col cols="12" md="5">
          موجودی فعلی:
          <span>{{ 540000 | toMoney }}</span>
          تومان
        </v-col>
        <v-col cols="12" md="4">
          <money label="مبلغ" class="mt-n1" />
        </v-col>
        <v-col cols="12" md="3">
          <v-btn color="success" block @click="redirectToGateway">
            افزایش موجودی
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </m-form>
</template>
<script>
import { MFormMixin } from "@/components/m-form";
import SubscriptionMixin from "./mixin";

export default {
  name: "Wallet",
  mixins: [MFormMixin, SubscriptionMixin],
  data() {
    return {
      item: {},
      baseUrl: "subscriptions/wallet",
      permissionBasename: null,
      cols: [
        {
          text: "عملیات",
          value: "type",
          items: this.transactionTypes,
        },
        {
          text: "مبلغ",
          value: "amount",
          type: "numeric",
        },
        {
          text: "تاریخ",
          value: "date",
          type: "date",
        },
        {
          text: "وضعیت",
          value: "_is_successful",
          type: "boolean",
        },
        {
          text: "کد پیگیری",
          value: "id", // todo: change this
        },
      ],
    };
  },
  computed: {
    title() {
      return "کیف پول";
    },
    items() {
      return [];
    },
  },
  methods: {
    redirectToGateway() {},
  },
};
</script>
